import Box from '@mui/material/Box';
import RoomHeader from './RoomHeader.jsx';
import SearchPanel from './SearchPanel.jsx';
import QueueList from './QueueList.jsx';
import PlayerBar from './PlayerBar.jsx';

/** Vista principal: cabecera + buscador/cola + barra fija inferior. */
export default function RoomScreen() {
  return (
    <>
      <RoomHeader />
      <Box
        component="main"
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'minmax(340px, 430px) minmax(0, 1fr)' },
          gridTemplateRows: { xs: 'auto auto', md: 'minmax(0, 1fr)' },
          alignContent: 'start',
          gap: { xs: 1.5, md: 2.5 },
          px: { xs: 1.5, md: 3 },
          pt: { xs: 1.5, md: 2.5 },
          pb: { xs: 'calc(var(--player-h) + 12px)', md: 'calc(var(--player-h) + 16px)' },
          overflowY: { xs: 'auto', md: 'hidden' },
        }}
      >
        <SearchPanel />
        <QueueList />
      </Box>
      <PlayerBar />
    </>
  );
}
